<template>
  <ConfirmDialog
    v-model="dialogModel"
    title="Archive Confirmation"
    @cancel="close"
    @confirm="archive"
  >
    <h4>Are you sure you want to archive {{ name }}?</h4>
  </ConfirmDialog>
</template>

<script>
import ConfirmDialog from "@/components/ConfirmDialog";

export default {
  components: { ConfirmDialog },
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    name: {
      type: String,
      default: null
    },
    action: {
      type: Function,
      default: null
    },
    dialog: Boolean,
    close: {
      type: Function,
      default: null
    }
},

  emits: ['update:dialog'],

  computed: {
    dialogModel: {
      get () { return this.dialog },
      set (value) { this.$emit('update:dialog', value) },
    },
  },

  methods: {
    async archive() {
      await this.action({ id: this.id, isArchived: true });
      this.close();
    },
  },
};
</script>

<style scoped></style>
